export default __webpack_public_path__ + "static/media/starswap_logo_blue.ebb6eca6.svg";